export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '81e705d8-e3c4-4356-bdb8-dfaadfedc6b3';
export const MODAL_CLOSE_SEC = 2.5;
